import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IDataOpt } from '../components/ui/SelectSearchReq';
import { AppStore } from '../store/applicationState';
import { GetSearchAuthors } from '../store/authors/actions';
import { IAuthor } from '../store/authors/types';

export const useSearchAuthors = () => {
  const [options, setOptions] = React.useState<IDataOpt[] | undefined>();

  const { Authors } = useSelector((store: AppStore) => store);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (Authors.data && Authors.data.authors) {
      const opt = Authors.data && Authors.data.authors.map((it) => ({ id: it.id, label: it.fio }));
      setOptions(opt);
    }
  }, [Authors.data]);

  const handleSearchAuthors = (value: string | IDataOpt, callBack?: (resData: IDataOpt[]) => void) => {
    if (value) {
      dispatch(
        GetSearchAuthors.request({
          data: { fio:(value as unknown as IDataOpt).title || String(value)},
          callBack: (succ, data) => {
            if (succ && Array.isArray(data) && callBack) {
              const opt = data.map((it: IAuthor) => ({ id: it.id, label: it.fio }));
              callBack(opt);
            } else {
              callBack && callBack(options || []);
            }
          },
        })
      );
    } else {
      callBack && callBack(options || []);
    }
  };

  return {
    options,
    handleSearchAuthors,
  };
};
